<script lang="ts">
  interface Props {
    label?: string;
    subLabel?: string;
  }

  let { label = '', subLabel = '' }: Props = $props();
</script>

<div class="caqh-record-sub-header">
  {#if label}
    <div class="label" class:has-sublabel={subLabel}>{label}</div>
  {/if}
  {#if subLabel}
    <div class="sub-label">{subLabel}</div>
  {/if}
</div>

<style>
  .label {
    font-weight: normal;
    font-size: 14px;
    line-height: 22px;
    margin-top: 8px;
  }
  .label.has-sublabel {
    font-weight: bold;
  }
  .sub-label {
    margin-top: 8px;
    color: var(--grey-dark);
  }
</style>
